export const LOGIN = 'LOGIN';
export const UPDATE_ABOUT = 'UPDATE_ABOUT';
export const UPDATE_IMAGE = 'UPDATE_IMAGE';
export const GET_TUTOR_PROFILE = 'GET_TUTOR_PROFILE';
export const GET_TUTOR_LESSON = 'GET_TUTOR_LESSON';
export const GET_TUTOR_INVITES = 'GET_TUTOR_INVITES';
export const SCHEDULE_LESSON = 'SCHEDULE_LESSON';
export const GET_SCHEDULE = 'GET_SCHEDULE';
export const GET_AVAILABILITY = 'GET_AVAILABILITY';
